import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import closeicon from "../../../assets/images/close.svg";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import { formatPremiumWithCurrency } from "../../../utils";
import { selectAmanForm } from "../../../redux/features/amanFormSlice";
import BackdropModal from "../../common/modal/backdropModal";

const AmanSummaryModal = ({ show, onClose }) => {
  const translate = useLanguageTranslate();
  const { i18n } = useTranslation();
  const isRTL = i18n.resolvedLanguage === "ar";

  const amanFormData = useSelector(selectAmanForm);
  const selectedPlan = amanFormData?.AMAN_PLAN_SELECTION;

  if (!show || !selectedPlan) return null;

  const quotationNumber = selectedPlan.quoteNumber || "N/A";

  const basePremium = selectedPlan.price || 0;
  const tax = basePremium * 0.1;
  const total = basePremium + tax;

  const formatCurrency = (amount) => {
    const currency = translate("BHD", "د.ب");
    const formattedNumber = formatPremiumWithCurrency(amount, "", "en-US");

    if (isRTL) {
      return (
        <span className="flex items-center gap-1 flex-row-reverse">
          <span>{currency}</span>
          <span>{formattedNumber}</span>
        </span>
      );
    }
    return `${currency} ${formattedNumber}`;
  };

  return (
    <BackdropModal show={show} onClose={onClose} hideClosebtn>
      <div dir={isRTL ? "rtl" : "ltr"}>
        <div className="flex justify-between items-center mb-4 -mt-6">
          <h2 className="text-[#1A2024] text-2xl not-italic font-medium leading-8 tracking-[-0.24px]">
            {translate("Summary", "ملخص")}
          </h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full max767:bg-[#E5E9EB]"
          >
            <img src={closeicon} alt="Close" className="w-6 h-6" />
          </button>
        </div>
        <div className="bg-white rounded-lg max-w-md max-h-[80vh] min-w-[624px] max767:min-w-full max767:h-auto">
          <div className="rounded-lg summary-content">
            <div className="flex items-center justify-between bg-[#E8F4D8] px-4 py-2.5 rounded-md mb-2">
              <span className="text-[#5B6871] text-xs not-italic font-medium leading-6">
                {translate("Quotation Number", "رقم التسعيرة")}
              </span>
              <span className="text-[#5B6871] text-xs not-italic font-medium leading-6">
                {quotationNumber}
              </span>
            </div>

            <div className="flex justify-between mb-2 px-0 py-2.5">
              <span className="text-[#1A2024] text-sm not-italic font-medium leading-6">
                {translate("Premium", "قسط التأمين")}
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {formatCurrency(basePremium)}
              </span>
            </div>

            <div className="flex justify-between mb-2 px-0 py-2.5 border-b-[#DDE2E4] border-b border-solid">
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {translate("VAT", "ضريبة القيمة المضافة")} 10%
              </span>
              <span className="text-[#1A2024] text-sm not-italic font-normal leading-6">
                {formatCurrency(tax)}
              </span>
            </div>

            <div className="flex justify-between px-0 py-2.5">
              <span className="text-[#1A2024] text-base not-italic font-bold leading-6">
                {translate("Total", "المجموع")}
              </span>
              <span className="text-[#1A2024] text-base not-italic font-extrabold leading-6">
                {formatCurrency(total)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </BackdropModal>
  );
};

export default AmanSummaryModal;
